'use client';

import React from 'react';

import { Spinner } from '@kit/ui/spinner';

/**
 * Full-width iOS-style auth button.
 * Primary variant uses the shared native accent when hosted by the app shell.
 * Ghost variant is transparent with text color.
 */
export function NativeAuthButton({
  children,
  onClick,
  type = 'button',
  disabled = false,
  loading = false,
  primaryColor,
  secondaryColor,
  appTextColor,
  variant = 'primary',
}: {
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
  loading?: boolean;
  primaryColor: string;
  secondaryColor: string;
  appTextColor?: string;
  variant?: 'primary' | 'ghost';
}) {
  if (variant === 'ghost') {
    return (
      <button
        type={type}
        onClick={onClick}
        disabled={disabled || loading}
        className="min-h-[44px] w-full rounded-xl py-3 text-center text-sm font-medium transition-opacity active:scale-[0.98] disabled:opacity-40"
        style={{
          color: `var(--native-auth-foreground, ${appTextColor || primaryColor})`,
          borderRadius: 'var(--native-auth-radius, 12px)',
        }}
      >
        {loading ? <Spinner className="mx-auto h-5 w-5" /> : children}
      </button>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className="min-h-[48px] w-full rounded-xl border-0 py-3.5 text-center text-base font-semibold transition-opacity active:scale-[0.98] disabled:opacity-40"
      style={{
        backgroundColor: `var(--native-auth-accent, ${primaryColor})`,
        color: `var(--native-auth-accent-foreground, ${secondaryColor || '#ffffff'})`,
        borderRadius: 'var(--native-auth-radius, 12px)',
      }}
    >
      {loading ? <Spinner className="mx-auto h-5 w-5" /> : children}
    </button>
  );
}
